<template>
  <nav v-if="items.length" class="party-subnav" aria-label="二级栏目">
    <button
      v-for="item in items"
      :key="item.key"
      type="button"
      :class="{ active: item.active }"
      @click="$emit('select', item)"
    >{{ item.label }}</button>
  </nav>
</template>
<script>
export default { name: 'PartySubnav', props: { items: { type: Array, default: () => [] } } }
</script>
